module.exports=function(scope){ return `// Ensure that the ZoomSDK is initialized before attempting to start activity
if(ZoomSDK.getStatus(ZoomSessionActivity.class) == ZoomSDKStatus.INITIALIZED) {
    Intent sessionIntent = new Intent(this, ZoomSessionActivity.class);
    startActivityForResult(sessionIntent, ZoomSDK.REQUEST_CODE_SESSION);
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/quickstart/android/02-start-enrollment.java.tpl